<script setup>
import { AvatarImage } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  src: { type: String, default: undefined },
  alt: { type: String, default: undefined },
  referrerPolicy: { type: String, default: undefined },
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <AvatarImage
    data-slot="avatar-image"
    :src="src"
    :alt="alt"
    :referrer-policy="referrerPolicy"
    :class="cn('aspect-square size-full object-cover', props.class)"
  />
</template>
